var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/General/Card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1843 5.41231L12.0006 5.24982L4.81688 5.41231C3.48572 5.44242 2.35862 6.40304 2.11793 7.7126C1.53621 10.8777 1.53621 14.1223 2.11793 17.2874C2.35862 18.597 3.48572 19.5576 4.81688 19.5877L12.0006 19.7502L19.1843 19.5877C20.5155 19.5576 21.6426 18.597 21.8833 17.2874C22.465 14.1223 22.465 10.8777 21.8833 7.7126C21.6426 6.40303 20.5155 5.44242 19.1843 5.41231ZM4.8508 6.91192L12.0006 6.7502L19.1504 6.91192C19.7707 6.92595 20.2958 7.37355 20.408 7.98375C20.5613 8.81774 20.6717 9.65758 20.7394 10.5H3.26182C3.32947 9.65758 3.43994 8.81774 3.59322 7.98375C3.70537 7.37355 4.23054 6.92595 4.8508 6.91192ZM3.18164 12.5C3.18164 14.0117 3.31883 15.5233 3.59322 17.0163C3.70537 17.6265 4.23054 18.0741 4.8508 18.0881L12.0006 18.2498L19.1504 18.0881C19.7707 18.0741 20.2958 17.6265 20.408 17.0163C20.6824 15.5233 20.8196 14.0117 20.8196 12.5H3.18164Z",
    fill: "#121316"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.d9d6d2a82596cc29291310ef216a92dd.svg";
export { ForwardRef as ReactComponent };